import { render, staticRenderFns } from "./LinkBudgetDialog.vue?vue&type=template&id=c08554ca&scoped=true"
import script from "./LinkBudgetDialog.vue?vue&type=script&lang=js"
export * from "./LinkBudgetDialog.vue?vue&type=script&lang=js"
import style0 from "./LinkBudgetDialog.vue?vue&type=style&index=0&id=c08554ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08554ca",
  null
  
)

export default component.exports